import { _ as _objectSpread2, c as colors, r as resetFocus, n as noFocus, a as _defineProperty, t as typography, s as sizes$9 } from './focus-057f85ef.esm.js';
import _pick from 'ramda/src/pick';
import { textSizes, headingSizes, motion, shadows, buttonSize, buttonSizes, buttonFill, buttonShape, buttonEqualSizes, borderPresets, iconSizes as iconSizes$1, space, spaceForBorder, headingPresets, headingDisplaySizes, borderWidths } from '@hover/blueprint-theme';
import { iconSizes, textSizes as textSizes$1 } from '@hover/blueprint-theme/components';
import _mergeDeepRight from 'ramda/src/mergeDeepRight';
import _mergeDeepWith from 'ramda/src/mergeDeepWith';
import { includes } from '@hover/utilities';
import { lighten, darken, transparentize, position, transitions, math } from 'polished';
import 'ramda/src/max';
import 'ramda/src/reduce';
import { theme } from '@chakra-ui/react';
import _prop from 'ramda/src/prop';
import _mapObjIndexed$1 from 'ramda/src/mapObjIndexed';
import { orient, cssVar, calc } from '@chakra-ui/theme-tools';

var pickSize = /*#__PURE__*/_pick(['width', 'height']);

var backgroundFor = function backgroundFor(status) {
  switch (status) {
    case 'success':
      return 'success.100';

    case 'warning':
      return 'warning.100';

    case 'error':
      return 'danger.100';

    default:
      return 'primary.100';
  }
};

var iconColorFor = function iconColorFor(status) {
  switch (status) {
    case 'success':
      return 'success.base';

    case 'warning':
      return 'warning.base';

    case 'error':
      return 'danger.base';

    default:
      return 'primary.base';
  }
};

var subtle = function subtle(_ref) {
  var status = _ref.status;
  return {
    container: {
      background: backgroundFor(status)
    },
    icon: {
      color: iconColorFor(status)
    }
  };
};

var Alert = {
  parts: ['container', 'title', 'description', 'icon', 'titleIcon'],
  baseStyle: {
    container: {
      alignItems: 'center',
      borderRadius: 300,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row'
    },
    description: {
      color: 'neutral.text',
      fontFamily: 'body',
      fontWeight: 'body'
    },
    icon: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0
    },
    titleIcon: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 100
    },
    title: {
      color: 'neutral.text',
      fontFamily: 'heading',
      fontWeight: 'heading'
    }
  },
  defaultProps: {
    variant: 'subtle',
    size: 'default'
  },
  variants: {
    subtle: subtle,
    toast: function toast(props) {
      var _subtle = subtle(props),
          icon = _subtle.icon,
          container = _subtle.container;

      return {
        icon: icon,
        container: _objectSpread2(_objectSpread2({}, container), {}, {
          borderRadius: 400,
          shadow: 'distance400'
        })
      };
    }
  },
  sizes: {
    small: {
      container: {
        paddingX: '300',
        paddingY: '200'
      },
      icon: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/pickSize(iconSizes.small)), {}, {
        marginRight: 300
      }),
      titleIcon: /*#__PURE__*/_objectSpread2({
        marginRight: 400
      }, /*#__PURE__*/pickSize(iconSizes.medium)),
      description: /*#__PURE__*/_objectSpread2({}, textSizes[400]),
      title: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, headingSizes[200]), {}, {
        marginBottom: '0'
      })
    },
    "default": {
      container: {
        paddingX: '400',
        paddingY: '300'
      },
      icon: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/pickSize(iconSizes.small)), {}, {
        marginRight: 300
      }),
      titleIcon: /*#__PURE__*/_objectSpread2({
        marginRight: 400
      }, /*#__PURE__*/pickSize(iconSizes.large)),
      description: /*#__PURE__*/_objectSpread2({}, textSizes[500]),
      title: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, headingSizes[300]), {}, {
        marginBottom: '100'
      })
    }
  }
};

var sizes$8 = {
  full: {
    header: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, headingSizes['600']), {}, {
      marginBottom: '300'
    }),
    dialog: {
      paddingX: '500',
      paddingTop: '400',
      paddingBottom: '500'
    },
    closeButton: {
      top: '300',
      right: '300'
    }
  },
  small: {
    header: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, headingSizes['600']), {}, {
      marginBottom: '300'
    }),
    dialog: {
      paddingX: '500',
      paddingTop: '400',
      paddingBottom: '500'
    },
    closeButton: {
      top: '300',
      right: '300'
    }
  },
  medium: {
    header: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, headingSizes['650']), {}, {
      marginBottom: '300'
    }),
    dialog: {
      paddingX: '600',
      paddingTop: '500',
      paddingBottom: '600'
    },
    closeButton: {
      top: '400',
      right: '400'
    }
  },
  large: {
    header: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, headingSizes['650']), {}, {
      marginBottom: '300'
    }),
    dialog: {
      paddingX: '600',
      paddingTop: '500',
      paddingBottom: '600'
    },
    closeButton: {
      top: '400',
      right: '400'
    }
  }
};
var baseStyle = {
  dialog: {
    boxSizing: 'content-box',
    background: 'neutral.0'
  },
  header: {
    padding: 0,
    color: 'neutral.text',
    fontFamily: 'heading',
    fontWeight: 'heading'
  },
  body: /*#__PURE__*/_objectSpread2({
    color: 'neutral.text',
    padding: 0,
    fontFamily: 'body',
    fontWeight: 'body'
  }, textSizes['500']),
  footer: {
    padding: 0,
    marginTop: '500'
  },
  overlay: {
    bg: 'overlayDark'
  },
  closeButton: {}
};

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var mergeSizes = /*#__PURE__*/_mergeDeepWith(function (left, right) {
  return [].concat(_toConsumableArray(Array.isArray(left) ? left : [left]), _toConsumableArray(Array.isArray(right) ? right : [right]));
});
/**
 * Merge a style object containing a set of discrete sizes to a single style
 * object that leverages responsive style props to apply each size to a
 * corresponding media query. The style object must include at least `small`,
 * `medium` and `large` sizes. The smallest and largest size (`tiny` and `huge`)
 * are optional and when omitted will simply be replaced by `small` and `large`
 * respectively in the resulting responsive object.
 *
 * @see https://chakra-ui.com/docs/styled-system/features/responsive-styles#the-array-syntax
 *
 * @param sizes object of sizes style objects with sizes as keys
 * @returns merged style object containing single size with array-style responsive values
 */


var mergeSizesToResponsive = function mergeSizesToResponsive(_ref) {
  var tiny = _ref.tiny,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      huge = _ref.huge;
  return [tiny !== null && tiny !== void 0 ? tiny : small, small, medium, large, huge !== null && huge !== void 0 ? huge : large].reduce(mergeSizes);
};

var modalSizes = /*#__PURE__*/_mergeDeepRight(sizes$8, {
  full: {
    dialog: {
      borderRadius: '0',
      width: '100%'
    }
  },
  small: {
    dialog: {
      borderRadius: '300',
      width: '750'
    }
  },
  medium: {
    dialog: {
      borderRadius: '300',
      width: '800'
    }
  },
  large: {
    dialog: {
      borderRadius: '300',
      width: '850'
    }
  }
});

var sizes$7 = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, modalSizes), {}, {
  "default": /*#__PURE__*/mergeSizesToResponsive( /*#__PURE__*/_objectSpread2({
    tiny: modalSizes.full
  }, modalSizes))
});
var Modal = {
  parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  baseStyle: baseStyle,
  sizes: sizes$7,
  defaultProps: {
    size: 'default'
  }
};

var AlertDialog = {
  parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  baseStyle: baseStyle,
  sizes: sizes$7,
  defaultProps: {
    size: 'default'
  }
};

/**
 * Color palettes with consistent scales
 * - Base color is `color.500`
 * - Scale goes from 50 to 900
 */
var normalPalettes = ['success', 'warning', 'danger', 'brandBrown', 'brandGreen', 'brandNavy', 'brandYellow', 'brandTan', 'brandOrange', 'brandRed'];
/**
 * Get styles for high-contrast foreground and
 * background colors for a given color scheme
 *
 * @param colorScheme color scheme from theme
 * @returns
 */

var colorFor$1 = function colorFor(colorScheme) {
  switch (colorScheme) {
    case 'primary':
      return {
        backgroundColor: 'primary.600',
        color: 'neutral.0'
      };

    case 'success':
      return {
        backgroundColor: 'success.500',
        color: 'neutral.0'
      };

    case 'warning':
      return {
        backgroundColor: 'warning.500',
        color: 'neutral.700'
      };

    case 'danger':
      return {
        backgroundColor: 'danger.500',
        color: 'neutral.0'
      };

    default:
      return {
        backgroundColor: 'neutral.600',
        color: 'neutral.0'
      };
  }
};

var getSoftColor = function getSoftColor(colorScheme) {
  switch (colorScheme) {
    case 'primary':
      return {
        backgroundColor: 'primary.100',
        color: 'primary.base'
      };

    case 'success':
      return {
        backgroundColor: 'success.100',
        color: 'success.base'
      };

    case 'warning':
      return {
        backgroundColor: 'warning.100',
        color: 'warning.600'
      };

    case 'danger':
      return {
        backgroundColor: 'danger.100',
        color: 'danger.base'
      };

    default:
      return null;
  }
};

var defaultSoftColor = {
  backgroundColor: 'neutral.100',
  // TODO: replace with a new neutral token at some point?
  color: /*#__PURE__*/lighten(0.1, colors.neutral[700])
};
/**
 * Get styles for soft contrast (e.g: dark red on red) foreground
 * and background colors for a given _brand_ color scheme
 *
 * @param colorScheme color scheme from theme
 * @returns
 */

var softBrandColorFor = function softBrandColorFor(colorScheme) {
  switch (colorScheme) {
    case 'brandYellow':
      return {
        backgroundColor: 'brandYellow.100',
        color: 'brandYellow.700'
      };

    case 'primary':
      return {
        backgroundColor: 'primary.100',
        color: 'primary.base'
      };

    case 'brandTan':
      return {
        backgroundColor: 'brandTan.200',
        color: 'brandTan.800'
      };

    case 'brandGreen':
    case 'brandBrown':
    case 'brandRed':
    case 'brandNavy':
    case 'brandOrange':
      return {
        backgroundColor: "".concat(colorScheme, ".100"),
        color: "".concat(colorScheme, ".500")
      };

    default:
      return defaultSoftColor;
  }
};
/**
 * Get styles for soft contrast (e.g: dark red on red) foreground
 * and background colors for a given brand or product color scheme
 *
 * @param colorScheme color scheme from theme
 * @returns
 */

var softColorFor = function softColorFor(colorScheme) {
  return getSoftColor(colorScheme) || softBrandColorFor(colorScheme);
};
var primary$1 = colors.primary,
    neutral$1 = colors.neutral;
var neutral625 = /*#__PURE__*/darken(0.1, neutral$1['600']);
var neutral650 = /*#__PURE__*/darken(0.2, neutral$1['600']);
var getStateColors = function getStateColors(colorScheme) {
  var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // Primary is weird, base is 600 instead of 500
  if (colorScheme === 'primary') {
    return {
      idle: raw ? primary$1.base : 'primary.base',
      hover: raw ? primary$1[700] : 'primary.700',
      active: raw ? primary$1[800] : 'primary.800',
      hoverBackground: raw ? primary$1[100] : 'primary.100',
      activeBackground: raw ? primary$1[200] : 'primary.200'
    };
  } // Everything else is base 500


  if (includes(normalPalettes, colorScheme)) {
    var palette = colors[colorScheme];
    return {
      idle: raw ? palette[500] : "".concat(colorScheme, ".500"),
      hover: raw ? palette[600] : "".concat(colorScheme, ".600"),
      active: raw ? palette[700] : "".concat(colorScheme, ".700"),
      hoverBackground: raw ? palette[100] : "".concat(colorScheme, ".100"),
      activeBackground: raw ? palette[200] : "".concat(colorScheme, ".200")
    };
  } // Default to neutral


  return {
    idle: raw ? neutral$1['600'] : 'neutral.600',
    hover: neutral625,
    active: neutral650,
    hoverBackground: raw ? neutral$1[100] : 'neutral.100',
    activeBackground: raw ? neutral$1[200] : 'neutral.200'
  };
};

var Badge = {
  baseStyle: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, textSizes[400]), {}, {
    borderRadius: 300,
    boxSizing: 'border-box',
    fontFamily: 'body',
    fontWeight: 'bodySemiBold',
    overflow: 'hidden',
    paddingX: 200,
    paddingY: 50,
    textTransform: 'uppercase'
  }),
  variants: {
    solid: function solid(props) {
      return colorFor$1(props.colorScheme);
    },
    brand: function brand(props) {
      return _objectSpread2({
        borderRadius: 500,
        fontSize: '50',
        lineHeight: '50',
        fontWeight: 'bold',
        paddingX: 400,
        paddingY: 200
      }, softBrandColorFor(props.colorScheme));
    }
  },
  defaultProps: {
    colorScheme: 'neutral',
    variant: 'solid'
  }
};

var Button$1 = {
  parts: ['button', 'content'],
  baseStyle: {
    button: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
      borderRadius: 900,
      boxSizing: 'border-box',
      fontFamily: 'body',
      fontWeight: 'bold',
      paddingY: 0,
      position: 'relative',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap'
    }, /*#__PURE__*/transitions(['background', 'border', 'color', 'text-decoration'], motion.easings[250])), {}, {
      // Pseudo-element for focus halo
      _after: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
        borderRadius: 900
      }, /*#__PURE__*/position('absolute', 0)), /*#__PURE__*/transitions(['bottom', 'box-shadow', 'left', 'right', 'top'], motion.easings[250])), {}, {
        shadow: 'invisibleNeutral',
        content: '""'
      })
    }, noFocus), /*#__PURE__*/resetFocus({
      _after: /*#__PURE__*/_objectSpread2({
        shadow: /*#__PURE__*/"0 0 0 3px ".concat( /*#__PURE__*/transparentize(0, colors.primary300))
      }, /*#__PURE__*/position('absolute', '-6px'))
    }, {
      _after: /*#__PURE__*/_objectSpread2({
        shadow: 'invisibleNeutral'
      }, /*#__PURE__*/position('absolute', 0))
    })),
    content: {},
    decoration: {
      fill: 'none',
      stroke: 'currentColor'
    }
  },
  sizes: {
    small: {
      button: {
        lineHeight: 50,
        fontSize: 100,
        height: 300
      },
      content: {
        paddingX: 600
      }
    },
    medium: {
      button: {
        lineHeight: 100,
        fontSize: 200,
        height: 400
      },
      content: {
        paddingX: 600
      }
    },
    large: {
      button: {
        lineHeight: 200,
        fontSize: 300,
        height: 500
      },
      content: {
        paddingX: 800
      }
    }
  },
  variants: {
    solid: function solid(_ref) {
      var colorScheme = _ref.colorScheme;

      var _getStateColors = getStateColors(colorScheme),
          active = _getStateColors.active,
          idle = _getStateColors.idle,
          hover = _getStateColors.hover;

      return {
        button: {
          background: idle,
          color: 'neutral.0',
          _hover: {
            background: hover
          },
          _active: {
            bacground: active
          }
        }
      };
    },
    inverted: function inverted(_ref2) {
      var colorScheme = _ref2.colorScheme;

      var _getStateColors2 = getStateColors(colorScheme),
          color = _getStateColors2.idle;

      return {
        button: {
          background: 'transparent',
          borderColor: 'neutral.0',
          borderStyle: 'solid',
          borderWidth: 500,
          position: 'relative',
          color: 'neutral.0',
          _hover: {
            background: 'neutral.0',
            color: color
          }
        }
      };
    },
    outline: function outline(_ref3) {
      var colorScheme = _ref3.colorScheme;

      var _getStateColors3 = getStateColors(colorScheme),
          idle = _getStateColors3.idle,
          hover = _getStateColors3.hover,
          active = _getStateColors3.active,
          hoverBackground = _getStateColors3.hoverBackground,
          activeBackground = _getStateColors3.activeBackground;

      return {
        button: {
          background: 'transparent',
          borderColor: idle,
          borderStyle: 'solid',
          borderWidth: 500,
          position: 'relative',
          color: idle,
          _hover: {
            background: hoverBackground,
            borderColor: hover,
            color: hover
          },
          _active: {
            background: activeBackground,
            borderColor: active,
            color: active
          }
        }
      };
    },
    minimal: function minimal(_ref4) {
      var colorScheme = _ref4.colorScheme;

      var _ref5 = colorScheme === 'neutral' ? {
        idle: 'neutral.0',
        hover: 'primary.200',
        active: 'primary.300'
      } : getStateColors(colorScheme),
          idle = _ref5.idle,
          hover = _ref5.hover,
          active = _ref5.active;

      return {
        button: {
          background: 'transparent',
          borderColor: 'transparent',
          borderStyle: 'solid',
          borderWidth: 500,
          color: idle,
          fontSize: 300,
          fontWeight: 'bodySemiBold',
          position: 'relative',
          textTransform: 'none',
          textDecoration: 'underline',
          textDecorationThickness: '1px',
          textDecorationColor: 'transparent',
          _hover: {
            textDecorationColor: 'currentColor',
            color: hover
          },
          _active: {
            textDecorationColor: 'currentColor',
            color: active
          }
        }
      };
    }
  },
  defaultProps: {
    size: 'medium',
    variant: 'solid',
    colorScheme: 'primary'
  }
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var hoverSelector = ':hover:not([disabled])';
var activeSelector = ':active:not([disabled])';
var neutral = colors.neutral;

var getFocus = function getFocus(colorScheme) {
  switch (colorScheme) {
    case 'primary':
      return {
        border: 'focus',
        boxShadow: shadows.haloPrimary
      };

    case 'success':
      return {
        border: 'focusSuccess',
        boxShadow: shadows.haloSuccess
      };

    case 'warning':
      return {
        border: 'focusWarning',
        boxShadow: shadows.haloWarning
      };

    case 'danger':
      return {
        border: 'focusDanger',
        boxShadow: shadows.haloDanger
      };

    default:
      return {
        border: 'focusNeutral',
        boxShadow: shadows.haloNeutral
      };
  }
};
/**
 * Build styles for `solid` button fill variant
 *
 * @param props `Button` props
 * @returns
 */


var colorForSolid = function colorForSolid(_ref) {
  var colorScheme = _ref.colorScheme,
      isDisabled = _ref.isDisabled;

  if (isDisabled) {
    return {
      backgroundColor: 'neutral.disabled',
      borderColor: 'transparent',
      color: 'neutral.0'
    };
  }

  var _getStateColors = getStateColors(colorScheme, true),
      active = _getStateColors.active,
      idle = _getStateColors.idle,
      hover = _getStateColors.hover;

  return _objectSpread2(_objectSpread2({
    color: neutral['0'],
    border: 'none'
  }, resetFocus(getFocus(colorScheme), {
    borderColor: 'transparent',
    shadow: 'invisibleNeutral'
  })), {}, {
    backgroundColor: idle,
    ':hover:not([disabled])': {
      backgroundColor: hover,
      borderColor: hover
    },
    ':active:not([disabled])': {
      backgroundColor: active,
      bordercolor: active
    }
  });
};

var getInversePalette = function getInversePalette(colorScheme) {
  var _getStateColors2 = getStateColors(colorScheme, true),
      activeColor = _getStateColors2.active,
      hoverColor = _getStateColors2.hover,
      color = _getStateColors2.idle,
      activeBackground = _getStateColors2.activeBackground,
      hoverBackground = _getStateColors2.hoverBackground;

  return {
    activeColor: activeColor,
    hoverColor: hoverColor,
    color: color,
    hoverBackground: hoverBackground,
    activeBackground: activeBackground
  };
};
/**
 * Build styles for `outline` button fill variant
 *
 * @param props `Button` props
 * @returns
 */


var colorForOutline = function colorForOutline(_ref2) {
  var _objectSpread2$1;

  var colorScheme = _ref2.colorScheme,
      isDisabled = _ref2.isDisabled;

  if (isDisabled) {
    return {
      backgroundColor: 'transparent',
      borderColor: 'neutral.disabled',
      color: 'neutral.disabled'
    };
  }

  var _getInversePalette = getInversePalette(colorScheme),
      color = _getInversePalette.color,
      hoverColor = _getInversePalette.hoverColor,
      hoverBackground = _getInversePalette.hoverBackground,
      activeColor = _getInversePalette.activeColor,
      activeBackground = _getInversePalette.activeBackground;

  var focus = getFocus(colorScheme);
  var idleShadow = "inset 0px 0px 0px 1px ".concat(transparentize(1, color));
  var hoverShadow = "inset 0px 0px 0px 1px ".concat(transparentize(0, hoverColor));
  var activeShadow = "inset 0px 0px 0px 1px ".concat(transparentize(0, activeColor));
  var idle = {
    color: color,
    backgroundColor: 'transparent',
    borderColor: 'currentcolor',
    boxShadow: [shadows.invisibleNeutral, idleShadow].join(',')
  };
  var hover = {
    color: hoverColor,
    backgroundColor: hoverBackground,
    boxShadow: [shadows.invisibleNeutral, hoverShadow].join(',')
  };
  var active = {
    color: activeColor,
    backgroundColor: activeBackground,
    boxShadow: [shadows.invisibleNeutral, activeShadow].join(',')
  };
  return _objectSpread2(_objectSpread2(_objectSpread2({}, idle), resetFocus(focus, idle)), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, hoverSelector, _objectSpread2(_objectSpread2({}, hover), resetFocus(_objectSpread2(_objectSpread2({}, focus), {}, {
    boxShadow: [focus.boxShadow, hoverShadow].join(',')
  }), hover))), _defineProperty(_objectSpread2$1, activeSelector, _objectSpread2(_objectSpread2({}, active), resetFocus(_objectSpread2(_objectSpread2({}, focus), {}, {
    boxShadow: [focus.boxShadow, activeShadow].join(',')
  }), active))), _objectSpread2$1));
};
/**
 * Build styles for `minimal` button fill variant
 *
 * @param props `Button` props
 * @returns
 */

var colorForMinimal = function colorForMinimal(_ref3) {
  var colorScheme = _ref3.colorScheme,
      isDisabled = _ref3.isDisabled;

  if (isDisabled) {
    return {
      backgroundColor: 'transparent',
      border: 'none',
      color: 'neutral.disabled'
    };
  }

  var _getInversePalette2 = getInversePalette(colorScheme),
      color = _getInversePalette2.color,
      hoverColor = _getInversePalette2.hoverColor,
      hoverBackground = _getInversePalette2.hoverBackground,
      activeColor = _getInversePalette2.activeColor,
      activeBackground = _getInversePalette2.activeBackground;

  var idle = {
    borderColor: transparentize(1, hoverColor),
    shadow: 'invisibleNeutral'
  };
  return _objectSpread2(_objectSpread2(_objectSpread2({
    backgroundColor: 'transparent',
    color: color
  }, resetFocus(getFocus(colorScheme), idle)), idle), {}, {
    ':hover:not([disabled])': {
      color: hoverColor,
      backgroundColor: hoverBackground
    },
    ':active:not([disabled])': {
      color: activeColor,
      backgroundColor: activeBackground
    }
  });
};

var getEqualSizeProps = function getEqualSizeProps(equal, _ref) {
  var _ref2, _buttonSizes$size;

  var width = _ref.width,
      height = _ref.height,
      size = _ref.size;
  if (!equal) return {};
  var dimension = (_ref2 = height !== null && height !== void 0 ? height : width) !== null && _ref2 !== void 0 ? _ref2 : includes(buttonSize, size) ? (_buttonSizes$size = buttonSizes[size]) === null || _buttonSizes$size === void 0 ? void 0 : _buttonSizes$size.height : undefined;
  return {
    paddingLeft: '0',
    paddingRight: '0',
    width: dimension,
    height: dimension
  };
};

var _excluded$1 = ["fill", "shape"];

var getFill = function getFill(variant) {
  var _buttonFill$find;

  return variant ? (_buttonFill$find = buttonFill.find(function (fill) {
    return new RegExp("^".concat(fill)).test(variant);
  })) !== null && _buttonFill$find !== void 0 ? _buttonFill$find : 'solid' : 'solid';
};

var getShape = function getShape(variant) {
  var _buttonShape$find;

  return variant ? (_buttonShape$find = buttonShape.find(function (shape) {
    return new RegExp("".concat(shape, "$")).test(variant);
  })) !== null && _buttonShape$find !== void 0 ? _buttonShape$find : 'pill' : 'pill';
};

var buildVariants = function buildVariants() {
  return buttonFill.flatMap(function (fill) {
    return buttonShape.map(function (shape) {
      return "".concat(fill, "-").concat(shape);
    });
  }).reduce(function (acc, variant) {
    return Object.assign(acc, _defineProperty({}, variant, {}));
  }, {});
};

var augment = function augment(fn) {
  return function (props) {
    return fn(_objectSpread2(_objectSpread2({}, props), {}, {
      fill: getFill(props.variant),
      shape: getShape(props.variant)
    }));
  };
};

var getColorStyles = function getColorStyles(_ref) {
  var fill = _ref.fill;
      _ref.shape;
      var props = _objectWithoutProperties(_ref, _excluded$1);

  switch (fill) {
    case 'minimal':
      return colorForMinimal(props);

    case 'outline':
      return colorForOutline(props);

    default:
      return colorForSolid(props);
  }
};

var Button = {
  baseStyle: /*#__PURE__*/augment(function (props) {
    var shape = props.shape;
    var isEqual = shape === 'circle' || shape === 'square';
    return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      alignItems: 'center',
      borderRadius: shape === 'pill' || shape === 'circle' ? '900' : '300',
      border: 'unset',
      borderStyle: 'solid',
      borderWidth: '400',
      borderColor: 'transparent',
      boxSizing: 'border-box',
      display: 'flex',
      fontFamily: 'body',
      fontWeight: 'bold',
      justifyContent: 'center',
      overflow: 'hidden'
    }, getEqualSizeProps(isEqual, props)), transitions(['color', 'background', 'border', 'box-shadow'], motion.easings[250])), getColorStyles(props)), {}, {
      cursor: 'pointer',
      _disabled: {
        cursor: 'default'
      }
    });
  }),
  variants: /*#__PURE__*/buildVariants(),
  sizes: buttonSizes,
  equalSizes: buttonEqualSizes,
  defaultProps: {
    colorScheme: 'neutral',
    size: 'default',
    variant: ''
  }
};

var _excluded = ["container"];
var CONTROL_SIZE_SMALL = 14;
var CONTROL_SIZE_MEDIUM = 18;
var CONTROL_SIZE_LARGE = 22;
var RADIO_DIFFERENCE = 2;
var RADIO_SIZE_SMALL = CONTROL_SIZE_SMALL - RADIO_DIFFERENCE;
var RADIO_SIZE_MEDIUM = CONTROL_SIZE_MEDIUM - RADIO_DIFFERENCE;
var RADIO_SIZE_LARGE = CONTROL_SIZE_LARGE - RADIO_DIFFERENCE;
var RADIO_CHECKED_SIZE_SMALL = RADIO_SIZE_SMALL / 2;
var RADIO_CHECKED_SIZE_MEDIUM = RADIO_SIZE_MEDIUM / 2;
var RADIO_CHECKED_SIZE_LARGE = RADIO_SIZE_LARGE / 2;

var px = function px(value) {
  return "".concat(value, "px");
};

var container = {
  display: 'inline-flex',
  alignItems: 'center',
  fontFamily: 'body',
  fontWeight: 'body'
};
var control = function control(_ref) {
  var isInvalid = _ref.isInvalid;
  return _objectSpread2(_objectSpread2({}, transitions(['background', 'border', 'box-shadow'], motion.easings[250])), {}, {
    _checked: {
      background: isInvalid ? 'danger.500' : 'primary.600',
      border: isInvalid ? 'invalid' : 'primary'
    },
    _focus: {
      border: isInvalid ? 'invalidFocus' : 'focus',
      shadow: isInvalid ? 'haloDanger' : 'haloPrimary',
      _checked: {
        border: isInvalid ? 'invalidFocus' : 'focus'
      }
    },
    _disabled: {
      background: 'neutral.100',
      cursor: 'not-allowed',
      borderColor: 'neutral.300',
      _after: {
        background: 'neutral.100'
      },
      _checked: {
        borderColor: 'neutral.300',
        background: 'neutral.300'
      }
    }
  });
};
var label = function label(_ref2) {
  var isInvalid = _ref2.isInvalid;
  return _objectSpread2({
    color: isInvalid ? 'danger.700' : 'neutral.700',
    cursor: 'pointer',
    insetEnd: 400,
    _disabled: {
      color: 'neutral.500',
      cursor: 'default'
    }
  }, transitions(['color'], motion.easings[250]));
};
/**
 * Conditionally add a vertical offset to control when `alignItems` is set to
 * `baseline` to align control with first line of the label when the label wraps
 *
 * @param offset vertical offset in pixels
 * @param alignItems align-items style prop (allows this offset to be overridden)
 * @returns translation to apply to control's `transform`
 */

var getTransform = function getTransform(offset, alignItems) {
  return alignItems && alignItems === 'baseline' ? "translateY(".concat(offset, "px)") : 'none';
}; // FIXME: use token or math for `_after` (radio indicator)


var sizes$6 = {
  small: function small(_ref3) {
    var alignItems = _ref3.alignItems;
    return {
      control: {
        width: px(CONTROL_SIZE_SMALL),
        height: px(CONTROL_SIZE_SMALL),
        transform: getTransform(2, alignItems),
        _after: {
          width: px(RADIO_SIZE_SMALL),
          height: px(RADIO_SIZE_SMALL)
        },
        _checked: {
          _after: {
            width: px(RADIO_CHECKED_SIZE_SMALL),
            height: px(RADIO_CHECKED_SIZE_SMALL)
          }
        }
      },
      label: _objectSpread2({}, textSizes$1[400])
    };
  },
  medium: function medium(_ref4) {
    var alignItems = _ref4.alignItems;
    return {
      control: {
        width: px(CONTROL_SIZE_MEDIUM),
        height: px(CONTROL_SIZE_MEDIUM),
        transform: getTransform(3, alignItems),
        _after: {
          width: px(RADIO_SIZE_MEDIUM),
          height: px(RADIO_SIZE_MEDIUM)
        },
        _checked: {
          _after: {
            width: px(RADIO_CHECKED_SIZE_MEDIUM),
            height: px(RADIO_CHECKED_SIZE_MEDIUM)
          }
        }
      },
      label: _objectSpread2({}, textSizes$1[500])
    };
  },
  large: function large(_ref5) {
    var alignItems = _ref5.alignItems;
    return {
      control: {
        width: px(CONTROL_SIZE_LARGE),
        height: px(CONTROL_SIZE_LARGE),
        transform: getTransform(4, alignItems),
        _after: {
          width: px(RADIO_SIZE_LARGE),
          height: px(RADIO_SIZE_LARGE)
        },
        _checked: {
          _after: {
            width: px(RADIO_CHECKED_SIZE_LARGE),
            height: px(RADIO_CHECKED_SIZE_LARGE)
          }
        }
      },
      label: _objectSpread2({}, textSizes$1[600])
    };
  }
};

var getTileContainerSize = function getTileContainerSize(size) {
  switch (size) {
    case 'small':
      return {
        padding: 200,
        gridTemplateRows: "".concat(typography.lineHeights[200], " 1fr"),
        gridColumnGap: 200
      };

    case 'large':
      return {
        padding: 400,
        gridTemplateRows: "".concat(typography.lineHeights[400], " 1fr"),
        gridColumnGap: 400
      };

    default:
      return {
        padding: 300,
        gridTemplateRows: "".concat(typography.lineHeights[300], " 1fr"),
        gridColumnGap: 300
      };
  }
};

var tileControlHoverSelector = /*#__PURE__*/['.chakra-checkbox:not([data-disabled]):hover &', '.chakra-radio:not([data-disabled]):hover &'].join(',');

var tile = function tile(_ref6) {
  var isInvalid = _ref6.isInvalid,
      size = _ref6.size;
  return {
    container: _objectSpread2(_objectSpread2({}, getTileContainerSize(size)), {}, {
      borderColor: isInvalid ? 'danger.300' : 'neutral.500',
      borderRadius: 300,
      borderStyle: 'solid',
      borderWidth: 400,
      cursor: 'pointer',
      display: 'grid',
      fontFamily: 'body',
      fontWeight: 'body',
      gridTemplateAreas: "\n        \"control label\"\n        \". description\"\n      ",
      gridTemplateColumns: 'min-content 1fr',
      justifyContent: 'start',
      _disabled: {
        borderColor: 'neutral.300',
        cursor: 'default'
      },
      _checked: {
        borderColor: isInvalid ? 'danger.700' : 'primary.700',
        background: isInvalid ? 'danger.100' : 'primary.100',
        _disabled: {
          borderColor: 'neutral.400',
          background: 'neutral.100'
        }
      },
      ':hover:not([data-disabled]):not([data-checked])': {
        borderColor: isInvalid ? 'danger.700' : 'primary.700',
        background: isInvalid ? 'danger.50' : 'primary.50'
      }
    }, transitions(['border', 'background'], motion.easings[250])),
    control: _defineProperty({
      alignSelf: 'center',
      justifyContent: 'center',
      gridArea: 'control'
    }, tileControlHoverSelector, {
      borderColor: isInvalid ? 'danger.700' : 'primary.700'
    }),
    label: {
      display: 'grid',
      gridRowGap: 100,
      gridRowStart: 1,
      gridRowEnd: 3,
      gridColumnStart: 2,
      gridColumnEnd: 3,
      margin: 0,
      overflow: 'hidden'
    }
  };
};

var variants = {
  "default": {},
  tile: tile,
  'subtle-tile': function subtleTile(props) {
    var _tile = tile(props),
        baseContainer = _tile.container,
        rest = _objectWithoutProperties(_tile, _excluded);

    var isInvalid = props.isInvalid;
    var fill = isInvalid ? 'danger.100' : 'primary.100';
    return _objectSpread2({
      container: _objectSpread2(_objectSpread2({}, baseContainer), {}, {
        borderColor: 'transparent',
        _checked: {
          borderColor: isInvalid ? 'danger.300' : 'primary.300',
          background: fill,
          _disabled: {
            borderColor: 'neutral.400',
            background: 'neutral.100'
          }
        },
        ':hover:not([data-disabled]):not([data-checked])': {
          borderColor: fill,
          background: fill
        }
      })
    }, rest);
  }
};

// FIXME: The `icon` part isn't currently responding to `_checked` etc., so
// we're setting `borderWidth` to zero and `borderColor` on the `control` part
// and inheriting said `borderColor` on the `icon`. This is just picking all
// the colors off of the `borderPresets` for convenience as we have to set
// `borderColor` for the inheritance to work instead of `border` presets.
var _mapObjIndexed = /*#__PURE__*/_mapObjIndexed$1( /*#__PURE__*/_prop('borderColor'), borderPresets),
    invalid = _mapObjIndexed.invalid,
    disabled = _mapObjIndexed.disabled,
    invalidFocus = _mapObjIndexed.invalidFocus,
    focus = _mapObjIndexed.focus,
    primary = _mapObjIndexed.primary;

var Checkbox = {
  parts: ['control', 'label', 'icon'],
  baseStyle: function baseStyle(props) {
    var isInvalid = props.isInvalid,
        size = props.size;
    return {
      container: container,
      label: label(props),
      icon: _objectSpread2({
        background: 'neutral.0',
        borderColor: 'inherit',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 400,
        boxSizing: 'border-box',
        fill: 'none',
        height: '100%',
        overflow: 'hidden',
        stroke: 'neutral.0',
        width: '100%'
      }, transitions(['border'], motion.easings[250])),
      control: _objectSpread2({
        border: isInvalid ? 'danger' : 'neutral',
        borderRadius: size === 'small' ? 200 : 300,
        borderWidth: 0,
        boxSizing: 'border-box',
        cursor: 'pointer',
        shadow: 'invisibleNeutral',
        _checked: {
          borderColor: isInvalid ? invalid : primary
        },
        _disabled: {
          cursor: 'not-allowed',
          borderColor: disabled
        },
        _hover: {
          borderColor: isInvalid ? 'danger.700' : 'primary.700',
          _disabled: {
            borderColor: disabled
          }
        },
        _focus: {
          borderColor: isInvalid ? invalidFocus : focus,
          shadow: isInvalid ? 'haloDanger' : 'haloPrimary'
        }
      }, transitions(['border', 'box-shadow', 'background'], motion.easings[250]))
    };
  },
  defaultProps: {
    size: 'default',
    variant: 'default'
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$6), {}, {
    "default": sizes$6.medium
  }),
  variants: variants
};

var colorsFor = function colorsFor(_ref) {
  var colorScheme = _ref.colorScheme,
      variant = _ref.variant;
  var hoverShade = variant === 'minimal' ? '100' : '200';

  switch (colorScheme) {
    case 'primary':
      return {
        bg: 'primary.100',
        _hover: {
          bg: "primary.".concat(hoverShade)
        },
        _focus: {
          bg: "primary.".concat(hoverShade)
        }
      };

    case 'success':
      return {
        bg: 'success.100',
        _hover: {
          bg: "success.".concat(hoverShade)
        },
        _focus: {
          bg: "success.".concat(hoverShade)
        }
      };

    case 'warning':
      return {
        bg: 'warning.100',
        _hover: {
          bg: "warning.".concat(hoverShade)
        },
        _focus: {
          bg: "warning.".concat(hoverShade)
        }
      };

    case 'danger':
      return {
        bg: 'danger.100',
        _hover: {
          bg: "danger.".concat(hoverShade)
        },
        _focus: {
          bg: "danger.".concat(hoverShade)
        }
      };

    default:
      {
        var neutralHoverShade = variant === 'minimal' ? '200' : '300';
        return {
          bg: 'neutral.200',
          _hover: {
            bg: "neutral.".concat(neutralHoverShade)
          },
          _focus: {
            bg: "neutral.".concat(neutralHoverShade)
          }
        };
      }
  }
};

var CloseButton = {
  baseStyle: function baseStyle(props) {
    return _objectSpread2(_objectSpread2(_objectSpread2({
      border: 'none',
      borderRadius: '200',
      cursor: 'pointer',
      outline: 'none',
      shadow: 'none'
    }, transitions(['background', 'border'], motion.easings[250])), _mergeDeepRight({
      _hover: {
        svg: {
          color: 'neutral.700'
        }
      },
      _focus: {
        shadow: 'none'
      }
    }, colorsFor(props))), {}, {
      svg: _objectSpread2(_objectSpread2({}, transitions(['color'], motion.easings[250])), {}, {
        color: 'neutral.600'
      }),
      _focusVisible: {
        outline: 'none'
      }
    });
  },
  defaultProps: {
    size: 'default',
    variant: 'solid'
  },
  sizes: {
    small: {
      width: '20px',
      height: '20px',
      svg: {
        width: '50',
        height: '50'
      }
    },
    "default": {
      width: '200',
      height: '200',
      svg: {
        width: '75',
        height: '75'
      }
    }
  },
  variants: {
    minimal: {
      bg: 'transparent',
      _hover: {}
    },
    solid: {}
  }
};

var Code = {
  baseStyle: function baseStyle(props) {
    return _objectSpread2({
      borderRadius: 300,
      color: 'neutral.600',
      fontFamily: 'mono',
      paddingX: 100
    }, softColorFor(props.colorScheme));
  },
  defaultProps: {
    colorScheme: 'neutral',
    size: '500',
    variant: 'default'
  },
  sizes: textSizes,
  variants: {
    "default": {},
    brand: {
      borderRadius: 500,
      paddingX: 200
    },
    outline: function outline(_ref) {
      var colorScheme = _ref.colorScheme;
      return {
        background: 'transparent',
        borderWidth: '400',
        borderStyle: 'solid',
        borderColor: "".concat(colorScheme !== null && colorScheme !== void 0 ? colorScheme : 'neutral', ".200")
      };
    },
    minimal: {
      background: 'transparent',
      border: 'none'
    }
  }
};

var Decoration = {
  baseStyle: {},
  defaultProps: {
    size: 'small'
  },
  sizes: iconSizes$1
};

var Divider = {
  baseStyle: {
    opacity: 1,
    borderStyle: 'solid'
  },
  defaultProps: {
    colorScheme: 'neutral',
    orientation: 'horizontal',
    variant: 'subtle',
    size: 'default'
  },
  sizes: {
    small: {
      borderBottomWidth: 400
    },
    "default": function _default(_ref) {
      var orientation = _ref.orientation;
      return _defineProperty({
        borderBottomWidth: 500
      }, orientation === 'horizontal' ? 'marginY' : 'marginX', 400);
    }
  },
  variants: {
    subtle: function subtle(props) {
      var _softColorFor = softColorFor(props.colorScheme),
          borderColor = _softColorFor.backgroundColor;

      return {
        borderColor: borderColor
      };
    }
  }
};

/**
 * Chakra doesn't currently make the `placement` prop available here so we
 * don't know whether the drawer is coming from the top/bottom or left/right. We
 * need to set `box-sizing` to `border-box` for top/bottom to be sized
 * correctly, but still want `content-box` for left/right so just compute it 🤷🏻‍♂️
 *
 * @param width size token for drawer width;
 * @param padding space token for drawer padding
 * @returns width in pixels
 */

var maxWidthFor = function maxWidthFor(width, padding) {
  return math("".concat(sizes$9[width], " + ").concat(space[padding], " * 2"));
};

var sizes$5 = /*#__PURE__*/_mergeDeepRight(sizes$8, {
  full: {
    dialog: {
      maxWidth: '100%'
    }
  },
  small: {
    dialog: {
      maxWidth: /*#__PURE__*/maxWidthFor(700, 500)
    }
  },
  medium: {
    dialog: {
      maxWidth: /*#__PURE__*/maxWidthFor(750, 600)
    }
  },
  large: {
    dialog: {
      maxWidth: /*#__PURE__*/maxWidthFor(800, 600)
    }
  }
});

var Drawer = {
  parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  baseStyle: /*#__PURE__*/_mergeDeepRight(baseStyle, {
    dialog: {
      boxSizing: 'border-box'
    }
  }),
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$5), {}, {
    "default": /*#__PURE__*/mergeSizesToResponsive( /*#__PURE__*/_objectSpread2({
      tiny: sizes$5.full
    }, sizes$5))
  }),
  defaultProps: {
    size: 'default'
  },
  variants: {
    persistent: {
      dialog: {
        pointerEvents: 'auto'
      },
      dialogContainer: {
        pointerEvents: 'none'
      }
    }
  }
};

var Form = {
  parts: ['container', 'helperText', 'requiredIndicator'],
  baseStyle: {
    container: {
      // Reset for when we render a `fieldset`
      border: 'none',
      margin: 0,
      padding: 0
    },
    helperText: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, textSizes$1[400]), {}, {
      fontFamily: 'body',
      fontWeight: 'body',
      color: 'neutral.600'
    }),
    requiredIndicator: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, textSizes$1[400]), {}, {
      fontFamily: 'body',
      fontWeight: 'body',
      color: 'neutral.600',
      marginLeft: 200
    }, /*#__PURE__*/transitions(['color'], motion.easings[250]))
  }
};

var spaceForIdleBorder$1 = /*#__PURE__*/spaceForBorder('idle'); // These are all required to hack around a hard-coded padding value in `Select`

var paddingVerticalMedium = /*#__PURE__*/spaceForIdleBorder$1(300);
var paddingVerticalSmall = /*#__PURE__*/spaceForIdleBorder$1(100);
var paddingVerticalTiny = /*#__PURE__*/spaceForIdleBorder$1(50);
var paddingHorizontalMedium = 400;
var paddingHorizontalSmall = 300;
var paddingHorizontalTiny = 200; // NOTE: we need to use an explicit height value here, which is why we're
// referencing the size tokens directly (e.g: `sizeTokens['400']` → `48px`)
// instead of using a theme preset (e.g: '400') because Chakra uses the raw
// value to compute the size of left/right input add-ons and elements

var sizes$4 = {
  "default": {
    field: /*#__PURE__*/_objectSpread2({
      height: sizes$9['400'],
      paddingY: paddingVerticalMedium,
      paddingX: paddingHorizontalMedium
    }, textSizes$1[500])
  },
  small: {
    field: /*#__PURE__*/_objectSpread2({
      height: sizes$9['300'],
      paddingY: paddingVerticalSmall,
      paddingX: paddingHorizontalSmall
    }, textSizes$1[500])
  },
  tiny: {
    field: /*#__PURE__*/_objectSpread2({
      height: sizes$9['200'],
      paddingY: paddingVerticalTiny,
      paddingX: paddingHorizontalTiny,
      borderRadius: '200'
    }, textSizes$1[400])
  }
};
var field = function field(_ref) {
  var isInvalid = _ref.isInvalid;
  return _objectSpread2(_objectSpread2({
    appearance: 'none',
    background: 'neutral.0',
    border: isInvalid ? 'invalid' : 'idle',
    boxSizing: 'border-box',
    color: isInvalid ? 'danger.700' : 'neutral.text',
    borderRadius: 300,
    fontFamily: 'body',
    fontWeight: 'body',
    minWidth: 0,
    outline: 0,
    position: 'relative'
  }, transitions(['border', 'box-shadow', 'color', 'background'], motion.easings[250])), {}, {
    shadow: 'invisibleNeutral',
    width: '100%',
    _placeholder: {
      color: 'neutral.400',
      opacity: 1
    },
    _focus: {
      border: isInvalid ? 'invalidFocus' : 'focus',
      shadow: isInvalid ? 'haloDanger' : 'haloPrimary'
    },
    _disabled: {
      background: 'neutral.100',
      border: 'disabled',
      color: 'neutral.600',
      cursor: 'not-allowed'
    }
  }, sizes$4["default"].field);
};

var FormError = {
  baseStyle: {
    text: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, textSizes$1[400]), {}, {
      color: 'danger.500',
      fontFamily: 'body',
      fontWeight: 'body'
    })
  },
  defaultProps: {
    size: 'default'
  },
  sizes: sizes$4
};

var FormLabel = {
  baseStyle: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, textSizes$1[400]), {}, {
    fontWeight: 'bodySemiBold',
    fontFamily: 'body',
    color: 'neutral.600',
    marginBottom: 100
  }, /*#__PURE__*/transitions(['color'], motion.easings[250])),
  defaultProps: {
    size: 'default'
  },
  sizes: sizes$4
};

var Heading = {
  baseStyle: {},
  defaultProps: {
    size: '600',
    variant: 'default'
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/_mapObjIndexed$1(function (size, key) {
    return _objectSpread2(_objectSpread2({}, size), {}, {
      marginBottom: headingPresets[key].marginBottom
    });
  }, headingSizes)), headingDisplaySizes),
  variants: {
    "default": {
      color: 'neutral.text',
      fontFamily: 'heading',
      fontWeight: 'heading'
    },
    display: {
      color: 'neutral.text',
      fontFamily: 'display',
      fontWeight: 'display'
    },
    light: {
      fontFamily: 'heading',
      fontWeight: 'headingLight'
    }
  }
};

var strokeWidths = {
  tiny: {
    strokeWidth: '2.5px'
  },
  small: {
    strokeWidth: '2px'
  },
  "default": {
    strokeWidth: '1.5px'
  },
  medium: {
    strokeWidth: '1.5px'
  },
  large: {
    strokeWidth: '1.35px'
  },
  huge: {
    strokeWidth: '1.25px'
  }
};
/**
 * This is a custom component as Chakra does support theming the built-in
 * `Icon` component. This component theme is applied to our custom icon
 * implementations such as `AwesomeIcon`
 *
 * @see `src/components/AwesomeIcon`
 */

var Icon = {
  baseStyle: {
    display: 'block'
  },
  defaultProps: {
    size: 'small'
  },
  sizes: /*#__PURE__*/_mergeDeepRight(iconSizes$1, strokeWidths)
};

var Input = {
  baseStyle: function baseStyle(props) {
    return {
      field: _objectSpread2({}, field(props))
    };
  },
  defaultProps: {
    size: 'default'
  },
  sizes: sizes$4
};

var Link = {
  baseStyle: function baseStyle(_ref) {
    var as = _ref.as,
        colorScheme = _ref.colorScheme;

    var _ref2 = colorScheme === 'neutral' ? {
      idle: 'neutral.0',
      hover: 'primary.200',
      active: 'primary.300'
    } : getStateColors(colorScheme),
        idle = _ref2.idle,
        hover = _ref2.hover,
        active = _ref2.active; // When the `as` prop is passed, we assume we're not rendering an anchor
    // tag and therefore we apply interaction styles unconditionally. When
    // rendering an anchor tag, only make the link look interactive when the
    // `href` attribute is present.


    var interaction = as ? {
      _hover: {
        color: hover
      }
    } : {
      ':not([href])': {
        color: 'neutral.600',
        cursor: 'default'
      },
      _hover: {
        '&[href]': {
          color: hover
        }
      }
    };
    return _objectSpread2(_objectSpread2(_objectSpread2({
      background: 'transparent',
      border: 'none',
      color: idle,
      fontWeight: 'bodySemiBold',
      fontFamily: 'body',
      position: 'relative',
      transition: "\n        text-decoration-color ".concat(motion.easings[150], ",\n        color ").concat(motion.easings[250], "\n      ")
    }, interaction), {}, {
      _active: {
        color: active
      },
      _before: _objectSpread2(_objectSpread2({
        content: '""',
        borderRadius: 300,
        opacity: 0,
        shadow: 'ringPrimary'
      }, position('absolute', '0px', '-1px', '0px', '-1px')), transitions(['opacity'], motion.easings[150]))
    }, resetFocus({
      _before: {
        opacity: 1
      }
    }, {
      _before: {
        opacity: 0
      }
    })), {}, {
      _focus: {
        shadow: 'none'
      }
    });
  },
  defaultProps: {
    colorScheme: 'primary',
    size: '500',
    variant: 'underline'
  },
  sizes: textSizes,
  variants: {
    underline: function underline(_ref3) {
      var as = _ref3.as;
      // When the `as` prop is passed, we assume we're not rendering an anchor
      // tag and therefore we apply interaction styles unconditionally. When
      // rendering an anchor tag, only make the link look interactive when the
      // `href` attribute is present.
      var interaction = as ? {
        _hover: {
          textDecorationColor: 'currentColor'
        }
      } : {
        _hover: {
          '&[href]': {
            textDecorationColor: 'currentColor'
          },
          '&:not([href])': {
            textDecorationColor: 'transparent'
          }
        }
      };
      return _objectSpread2({
        textDecoration: 'underline',
        textDecorationColor: 'transparent',
        _active: {
          textDecorationColor: 'transparent'
        }
      }, interaction);
    },
    minimal: {
      textDecoration: 'none',
      _hover: {
        textDecoration: 'none'
      }
    }
  }
};

var sizes$3 = {
  small: {
    container: {
      paddingLeft: '300'
    },
    icon: /*#__PURE__*/_objectSpread2({
      width: '50',
      height: '50',
      marginTop: '0.5em'
    }, textSizes[400]),
    item: /*#__PURE__*/_objectSpread2({}, textSizes[400])
  },
  medium: {
    container: {
      paddingLeft: '500'
    },
    icon: /*#__PURE__*/_objectSpread2({
      width: '75',
      height: '75',
      marginTop: '0.4em'
    }, textSizes[500]),
    item: /*#__PURE__*/_objectSpread2({}, textSizes[500])
  },
  large: {
    container: {
      paddingLeft: '600'
    },
    icon: /*#__PURE__*/_objectSpread2({
      width: '100',
      height: '100',
      marginTop: '0.35em'
    }, textSizes[600]),
    item: /*#__PURE__*/_objectSpread2({}, textSizes[600])
  }
};
var List = {
  parts: ['container', 'icon', 'item'],
  baseStyle: {
    container: {
      margin: 0
    },
    icon: {
      transform: "translateX(calc(-100% - 0.4em))",
      margin: 0,
      display: 'inline-block',
      position: 'absolute'
    },
    item: {
      color: 'neutral.text',
      padding: 0,
      position: 'relative',
      fontFamily: 'body',
      fontWeight: 'body'
    }
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3), {}, {
    "default": sizes$3.medium
  }),
  defaultProps: {
    size: 'default'
  }
};

var Menu = {
  parts: ['button', 'list', 'item', 'groupTitle', 'command', 'divider'],
  baseStyle: function baseStyle(_ref) {
    var colorScheme = _ref.colorScheme;

    var hover = _pick(['backgroundColor'], softColorFor(colorScheme));

    return {
      command: _objectSpread2({
        color: 'neutral.600',
        fontFamily: 'body',
        fontWeight: 500,
        opacity: 1
      }, textSizes[400]),
      divider: {
        color: 'neutral.200',
        marginX: 300,
        marginY: 200,
        opacity: 1
      },
      groupTitle: _objectSpread2({
        color: 'neutral.600',
        fontFamily: 'body',
        fontWeight: 'bodySemiBold',
        margin: 0,
        paddingX: 300,
        paddingY: 200,
        textTransform: 'uppercase'
      }, textSizes[300]),
      item: _objectSpread2(_objectSpread2({
        background: 'transparent',
        border: 0,
        color: 'neutral.text',
        cursor: 'pointer',
        fontFamily: 'body',
        paddingX: 300,
        paddingY: 100
      }, textSizes[500]), {}, {
        _disabled: {
          cursor: 'default'
        },
        _hover: hover
      }, resetFocus(hover)),
      list: {
        background: 'neutral.0',
        border: 'none',
        borderRadius: 300,
        paddingX: 0,
        paddingY: 100,
        shadow: 'distance300'
      }
    };
  },
  sizes: {},
  variants: {
    "default": {},
    navigation: function navigation(_ref2) {
      var colorScheme = _ref2.colorScheme;
      var indicatorThickness = '4px';

      var hover = _objectSpread2(_objectSpread2({}, softColorFor(colorScheme)), {}, {
        _before: {
          borderLeftWidth: indicatorThickness,
          opacity: 1
        }
      });

      return {
        divider: {
          color: 'neutral.400',
          marginX: 600,
          marginY: 400
        },
        groupTitle: _objectSpread2({
          color: 'neutral.600',
          paddingX: 600,
          paddingY: 200,
          textTransform: 'uppercase'
        }, textSizes[400]),
        item: _objectSpread2(_objectSpread2({
          position: 'relative',
          paddingX: 800,
          paddingY: 100
        }, transitions(['color'], motion.easings[250])), {}, {
          _before: _objectSpread2({
            content: '""',
            position: 'absolute',
            borderColor: hover.color,
            borderWidth: 0,
            borderStyle: 'solid',
            left: 0,
            opacity: 0,
            width: '100%',
            height: '100%'
          }, transitions(['border', 'opacity'], motion.easings[250])),
          _hover: hover,
          _focus: hover
        }),
        list: {
          borderRadius: 500,
          paddingTop: 400,
          paddingBottom: 500,
          shadow: 'distance400'
        }
      };
    }
  },
  defaultProps: {
    size: 'default',
    variant: 'default'
  }
};

var Popover = {
  parts: ['popper', 'content', 'header', 'body', 'footer', 'arrow', 'closeButton'],
  baseStyle: {
    popper: {},
    body: {
      paddingY: 300,
      paddingX: 100
    },
    closeButton: {
      borderRadius: 200,
      top: 200,
      right: 200,
      padding: 0,
      opacity: 0.8
    },
    content: /*#__PURE__*/_objectSpread2({
      background: 'neutral.0',
      border: 'none',
      borderRadius: 300,
      paddingX: 300,
      paddingY: 100,
      shadow: 'distance300',
      width: 700,
      _focus: {
        shadow: /*#__PURE__*/[shadows.distance300, shadows.ringNeutral].join(',')
      }
    }, /*#__PURE__*/transitions(['box-shadow'], motion.easings[250])),
    header: {
      paddingX: 0,
      borderBottomColor: 'neutral.200',
      fontWeight: 'heading'
    },
    footer: {
      paddingX: 0,
      borderTopColor: 'neutral.200'
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {
    size: 'default',
    variant: 'default'
  }
};

var Radio = {
  parts: ['container', 'control', 'label'],
  baseStyle: function baseStyle(props) {
    var isInvalid = props.isInvalid;
    return {
      container: container,
      label: label(props),
      control: _objectSpread2(_objectSpread2({}, control(props)), {}, {
        border: isInvalid ? 'danger' : 'neutral',
        borderRadius: 900,
        background: 'neutral.0',
        boxSizing: 'border-box',
        shadow: 'invisibleNeutral',
        cursor: 'pointer',
        _after: _objectSpread2({
          background: 'neutral.0',
          borderRadius: 900,
          content: '""',
          position: 'absolute'
        }, transitions(['height', 'width'], motion.easings[250])),
        _hover: {
          borderColor: isInvalid ? 'danger.700' : 'primary.700'
        }
      })
    };
  },
  defaultProps: {
    size: 'default'
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$6), {}, {
    "default": sizes$6.medium
  }),
  variants: variants
};

/**
 * Hack around the hard-coded `paddingEnd` value in Chakra that controls the
 * spacing between the field and the icon in `Select` by providing a shorthand
 * padding value (otherwise the hard-coded value overrides any attempts to set
 * `paddingEnd`)
 *
 * @param paddingVertical vertical padding with CSS units
 * @param paddingLeft space token for padding left
 * @param paddingRight space token for padding right
 * @returns
 */

var applyPaddingFix = function applyPaddingFix(paddingVertical, paddingLeft, paddingRight) {
  return {
    padding: [paddingVertical, space[paddingRight], paddingVertical, space[paddingLeft]].join(' ')
  };
};

var Select = {
  parts: ['field', 'icon'],
  baseStyle: function baseStyle(props) {
    return {
      field: _mergeDeepRight({
        cursor: 'pointer',
        appearance: 'none',
        lineHeight: 'normal',
        _focus: {
          '+ div': {
            color: props.isInvalid ? 'danger.700' : 'secondary.600'
          }
        },
        '> option, > optgroup': {
          bg: 'neutral.0'
        }
      }, field(props)),
      icon: _objectSpread2({
        color: props.isInvalid ? 'danger.600' : 'neutral.600',
        insetEnd: 400
      }, transitions(['color'], motion.easings[250]))
    };
  },
  defaultProps: {
    size: 'default',
    iconSize: '2em'
  },
  sizes: /*#__PURE__*/_mergeDeepRight({
    "default": {
      field: /*#__PURE__*/applyPaddingFix(paddingVerticalMedium, paddingHorizontalMedium, 700),
      icon: {
        insetEnd: 400
      }
    },
    small: {
      field: /*#__PURE__*/applyPaddingFix(paddingVerticalSmall, paddingHorizontalSmall, 600),
      icon: {
        insetEnd: 300
      }
    },
    tiny: {
      field: /*#__PURE__*/applyPaddingFix(paddingVerticalTiny, paddingHorizontalTiny, 500),
      icon: {
        insetEnd: 200
      }
    }
  }, sizes$4)
};

var $suggestedValueRadius = /*#__PURE__*/cssVar('suggested-value-radius');
var $thumbRadius = /*#__PURE__*/cssVar('thumb-radius');
var $trackSize = /*#__PURE__*/cssVar('track-size');
var focusOffset = /*#__PURE__*/calc.divide($thumbRadius, 4);
var suggestedValueInset = /*#__PURE__*/calc.divide($trackSize, 1.4);
var suggestedValueOffset = /*#__PURE__*/calc.divide( /*#__PURE__*/calc.multiply($suggestedValueRadius, -1), 2); // NOTE: For some reason, we have to use functions instead of just objects when
// using `cssVar('name').variable` to set these variables, otherwise they don't
// end up getting set in the CSS when rendered for the first time in a very
// specific case that only occurs when deployed in the production build... 🤨

var sizes$2 = {
  small: function small() {
    var _container;

    return {
      container: (_container = {}, _defineProperty(_container, $suggestedValueRadius.variable, sizes$9[100]), _defineProperty(_container, $thumbRadius.variable, sizes$9[75]), _defineProperty(_container, $trackSize.variable, sizes$9[25]), _container)
    };
  },
  medium: function medium() {
    var _container2;

    return {
      container: (_container2 = {}, _defineProperty(_container2, $suggestedValueRadius.variable, sizes$9[200]), _defineProperty(_container2, $thumbRadius.variable, sizes$9[100]), _defineProperty(_container2, $trackSize.variable, sizes$9[50]), _container2)
    };
  },
  large: function large() {
    var _container3;

    return {
      container: (_container3 = {}, _defineProperty(_container3, $suggestedValueRadius.variable, sizes$9[300]), _defineProperty(_container3, $thumbRadius.variable, sizes$9[200]), _defineProperty(_container3, $trackSize.variable, sizes$9[75]), _container3)
    };
  }
};
var backgroundTransition = /*#__PURE__*/transitions(['background'], motion.easings[150]);
var Slider = {
  parts: ['container', 'filledTrack', 'suggestedValueTrack', 'suggestedValue', 'thumb', 'track'],
  baseStyle: function baseStyle(_ref) {
    var orientation = _ref.orientation;
    var suggestedValueTransform = "translate(".concat(suggestedValueOffset, ", ").concat(orientation && orientation === 'vertical' ? '50%' : '-50%', ")");
    return {
      container: {
        _disabled: {
          opacity: 1
        }
      },
      suggestedValueTrack: _objectSpread2(_objectSpread2({
        background: 'neutral.200',
        borderRadius: 900,
        transform: suggestedValueTransform,
        width: $suggestedValueRadius.reference,
        height: $suggestedValueRadius.reference
      }, backgroundTransition), {}, {
        zIndex: 2,
        '&[data-filled]': {
          background: 'primary.500',
          '[aria-disabled] &': {
            background: 'neutral.300'
          }
        },
        '[aria-disabled] &': {
          background: 'neutral.100'
        }
      }),
      suggestedValue: {
        borderRadius: 900,
        transform: suggestedValueTransform,
        width: $suggestedValueRadius.reference,
        height: $suggestedValueRadius.reference,
        zIndex: 4,
        _after: _objectSpread2(_objectSpread2({}, position('absolute', suggestedValueInset)), {}, {
          borderRadius: 900,
          content: '""',
          background: 'neutral.0'
        })
      },
      thumb: _objectSpread2(_objectSpread2({
        background: 'neutral.0',
        borderRadius: 900,
        width: $thumbRadius.reference,
        height: $thumbRadius.reference,
        shadow: 'distance200',
        position: 'relative',
        zIndex: 5
      }, transitions(['box-shadow', 'transform'], motion.easings[250])), {}, {
        _before: _objectSpread2(_objectSpread2({
          borderRadius: 900,
          content: "''",
          shadow: 'invisibleNeutral'
        }, position('absolute', '-1px')), transitions(['box-shadow', 'transform'], motion.easings[250])),
        _after: _objectSpread2(_objectSpread2({
          background: 'primary.200',
          borderRadius: 900,
          content: "''",
          opacity: 0
        }, position('absolute', focusOffset)), transitions(['opacity'], motion.easings[250])),
        _active: {
          shadow: 'distance300',
          _before: {
            shadow: 'invisibleNeutral'
          }
        },
        _focus: {
          shadow: 'distance200',
          _before: {
            shadow: 'haloPrimary'
          },
          '&[data-suggested]:after': {
            opacity: 1
          }
        },
        _disabled: {
          background: 'neutral.50'
        }
      }),
      track: _objectSpread2(_objectSpread2({
        borderRadius: 900,
        background: 'neutral.200',
        zIndex: 1
      }, backgroundTransition), {}, {
        _disabled: {
          background: 'neutral.100'
        }
      }, orient({
        orientation: orientation,
        horizontal: {
          h: $trackSize.reference
        },
        vertical: {
          w: $trackSize.reference
        }
      })),
      filledTrack: _objectSpread2(_objectSpread2({
        background: 'primary.500',
        '[aria-disabled] &': {
          background: 'neutral.300'
        },
        borderRadius: 900,
        zIndex: 3
      }, backgroundTransition), orient({
        orientation: orientation,
        horizontal: {
          h: $trackSize.reference
        },
        vertical: {
          w: $trackSize.reference
        }
      }))
    };
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$2), {}, {
    "default": sizes$2.medium
  }),
  defaultProps: {
    size: 'default'
  }
};

var TRACK_LENGTH = 1;
var spaceForIdleBorder = /*#__PURE__*/spaceForBorder('idle');

var getTrackWidth = function getTrackWidth(size) {
  return math("".concat(sizes$9[size], " * ").concat(1 + TRACK_LENGTH));
};

var applySpacing = function applySpacing(spacing) {
  return function (_ref) {
    var _ref2;

    var flexDirection = _ref.flexDirection;
    return _ref2 = {}, _defineProperty(_ref2, flexDirection === 'row' ? 'marginStart' : 'marginEnd', spacing), _defineProperty(_ref2, flexDirection === 'row-reverse' ? 'marginStart' : 'marginEnd', 0), _ref2;
  };
};

var sizes$1 = {
  small: function small(props) {
    return {
      thumb: {
        height: 100,
        width: 100
      },
      track: {
        width: getTrackWidth(100)
      },
      label: _objectSpread2(_objectSpread2({}, textSizes[400]), applySpacing(100)(props))
    };
  },
  medium: function medium(props) {
    return {
      thumb: {
        height: 200,
        width: 200
      },
      track: {
        width: getTrackWidth(200)
      },
      label: _objectSpread2(_objectSpread2({}, textSizes[500]), applySpacing(200)(props))
    };
  },
  large: function large(props) {
    return {
      thumb: {
        height: 300,
        width: 300
      },
      track: {
        width: getTrackWidth(300)
      },
      label: _objectSpread2(_objectSpread2({}, textSizes[600]), applySpacing(200)(props))
    };
  }
};
var Switch = {
  parts: ['container', 'control', 'label'],
  baseStyle: function baseStyle(props) {
    return {
      container: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      },
      label: _objectSpread2(_objectSpread2({}, label(props)), {}, {
        fontFamily: 'body',
        fontWeight: 'body'
      }),
      thumb: {
        _checked: {
          transform: "translateX(".concat(TRACK_LENGTH * 100, "%)")
        }
      },
      track: _objectSpread2(_objectSpread2({}, _mergeDeepRight(control(props), {
        _disabled: {
          background: 'neutral.300',
          _checked: {
            background: 'primary.300',
            borderColor: 'primary.300'
          }
        }
      })), {}, {
        border: "".concat(borderWidths[400], " solid ").concat(colors.neutral[400]),
        padding: spaceForIdleBorder(100),
        background: 'neutral.400'
      })
    };
  },
  defaultProps: {
    flexDirection: 'row',
    size: 'default'
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$1), {}, {
    "default": sizes$1.medium
  })
};

var numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end'
  }
};
var Table = {
  parts: ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'tfoot'],
  baseStyle: {
    table: {
      fontFamily: 'body',
      color: 'neutral.700',
      bgColor: 'neutral.0'
    },
    th: /*#__PURE__*/_objectSpread2({
      color: 'neutral.600',
      fontFamily: 'body',
      fontWeight: '400',
      textTransform: 'none',
      letterSpacing: 'normal'
    }, numericStyles),
    td: /*#__PURE__*/_objectSpread2({}, numericStyles),
    tbody: {
      borderTop: '1px',
      borderBottom: '1px',
      borderColor: 'neutral.300'
    },
    tfoot: {
      paddingY: '400',
      paddingX: '200',
      _first: {
        paddingLeft: '400'
      },
      _last: {
        paddingRight: '400'
      }
    }
  },
  sizes: {
    small: {
      table: /*#__PURE__*/_objectSpread2({}, textSizes[400]),
      th: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, textSizes[400]), {}, {
        paddingY: '300',
        paddingX: '100',
        _first: {
          paddingLeft: '300'
        },
        _last: {
          paddingRight: '300'
        }
      }),
      td: {
        paddingY: '300',
        paddingX: '100',
        _first: {
          paddingLeft: '300'
        },
        _last: {
          paddingRight: '300'
        }
      }
    },
    medium: {
      table: /*#__PURE__*/_objectSpread2({}, textSizes[500]),
      th: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, textSizes[500]), {}, {
        paddingY: '400',
        paddingX: '200',
        _first: {
          paddingLeft: '400'
        },
        _last: {
          paddingRight: '400'
        }
      }),
      td: {
        paddingY: '400',
        paddingX: '200',
        _first: {
          paddingLeft: '400'
        },
        _last: {
          paddingRight: '400'
        }
      }
    }
  },
  variants: {
    "default": {}
  },
  defaultProps: {
    size: 'medium',
    variant: 'default'
  }
};

var INDICATOR_THICKNESS = '4px';

var spaceForIndicator = function spaceForIndicator(value) {
  return math("".concat(space[value], " - ").concat(INDICATOR_THICKNESS));
};

var sizes = {
  small: function small(_ref) {
    var orientation = _ref.orientation;
    return {
      heading: {
        marginLeft: orientation === 'vertical' ? 500 : 400,
        marginTop: 600,
        width: 700
      },
      tab: _objectSpread2({
        paddingX: orientation === 'vertical' ? 500 : 400,
        paddingTop: orientation === 'vertical' ? 200 : 300,
        paddingBottom: orientation === 'vertical' ? 200 : spaceForIndicator(300)
      }, textSizes[400])
    };
  },
  medium: function medium(_ref2) {
    var orientation = _ref2.orientation;
    return {
      heading: {
        marginLeft: orientation === 'vertical' ? 600 : 500,
        marginTop: 600,
        width: 700
      },
      tab: _objectSpread2({
        paddingX: orientation === 'vertical' ? 600 : 500,
        paddingTop: orientation === 'vertical' ? 300 : 400,
        paddingBottom: orientation === 'vertical' ? 300 : spaceForIndicator(400)
      }, textSizes[500])
    };
  },
  large: function large(_ref3) {
    var orientation = _ref3.orientation;
    return {
      heading: {
        marginLeft: orientation === 'vertical' ? 600 : 500,
        marginTop: 600,
        width: 700
      },
      tab: _objectSpread2({
        paddingX: orientation === 'vertical' ? 600 : 500,
        paddingTop: orientation === 'vertical' ? 400 : 500,
        paddingBottom: orientation === 'vertical' ? 400 : spaceForIndicator(400)
      }, textSizes[600])
    };
  }
};
var Tabs = {
  parts: ['heading', 'indicator', 'root', 'tab', 'tablist', 'tabpanel', 'tabpanels'],
  baseStyle: {
    heading: {
      borderBottomColor: 'neutral.200',
      borderBottomStyle: 'solid',
      borderBottomWidth: 400,
      fontSize: '200',
      lineHeight: '200',
      marginBottom: 0,
      textTransform: 'uppercase'
    },
    tab: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, noFocus), {}, {
      fontFamily: 'body',
      color: 'neutral.700',
      cursor: 'pointer'
    }, /*#__PURE__*/transitions(['border-color', 'background-color'], motion.easings[250])), {}, {
      _focus: {
        boxShadow: 'none'
      },
      _disabled: {
        cursor: 'default'
      }
    }),
    tabpanels: {
      boxSizing: 'border-box'
    },
    tabpanel: {
      padding: 300
    }
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes), {}, {
    "default": sizes.medium
  }),
  defaultProps: {
    size: 'default',
    variant: 'secondary'
  },
  variants: {
    secondary: function secondary(props) {
      var _objectSpread2$1;

      var orientation = props.orientation;
      var isVertical = orientation === 'vertical';
      var borderProp = orientation === 'vertical' ? 'borderStartWidth' : 'borderBottomWidth';
      return {
        tablist: _objectSpread2({
          borderColor: 'inherit',
          background: 'neutral.100'
        }, isVertical ? {
          borderRightColor: 'neutral.200',
          borderRightStyle: 'solid',
          borderRightWidth: 400
        } : {}),
        tab: _objectSpread2((_objectSpread2$1 = {
          boxSizing: 'border-box',
          background: 'transparent',
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderWidth: 0,
          justifyContent: isVertical ? 'start' : 'center'
        }, _defineProperty(_objectSpread2$1, borderProp, INDICATOR_THICKNESS), _defineProperty(_objectSpread2$1, "_selected", _defineProperty({
          color: 'primary.base',
          borderColor: 'primary.base'
        }, borderProp, INDICATOR_THICKNESS)), _defineProperty(_objectSpread2$1, "_active", {}), _defineProperty(_objectSpread2$1, "_disabled", {
          color: 'neutral.500'
        }), _defineProperty(_objectSpread2$1, "_hover", {
          color: 'primary.500',
          _disabled: {
            color: 'neutral.500'
          }
        }), _objectSpread2$1), resetFocus({
          background: 'neutral.200'
        }, true))
      };
    }
  }
};

var SMALL_CONTENT_SIZE = '16px';
var MEDIUM_CONTENT_SIZE = '20px';
var LARGE_CONTENT_SIZE = sizes$9[200];

var colorFor = function colorFor(colorScheme, field) {
  switch (colorScheme) {
    case 'primary':
      return {
        bg: 'primary.600',
        color: field === 'container' ? 'neutral.0' : 'primary.200'
      };

    case 'neutralDark':
      return {
        bg: 'neutral.600',
        color: field === 'container' ? 'neutral.0' : 'neutral.200'
      };

    default:
      return {
        bg: 'neutral.100',
        color: field === 'container' ? 'neutral.700' : 'neutral.600'
      };
  }
};

var hoverBackgroundFor = function hoverBackgroundFor(colorScheme) {
  switch (colorScheme) {
    case 'primary':
      return 'primary.700';

    case 'neutralDark':
      return 'neutral.700';

    default:
      return 'neutral.200';
  }
};

var Tag = {
  parts: ['closeButton', 'container', 'icon', 'label'],
  baseStyle: {
    closeButton: {
      padding: 0,
      svg: {
        width: '50%',
        height: '50%'
      }
    },
    icon: {
      boxSizing: 'border-box',
      svg: {
        // Overriding inline styles set by Font Awesome here, this can be
        // removed when we stop using the Font Awesome React component
        position: 'static !important',
        width: '100%',
        height: '100%'
      }
    },
    label: {
      display: 'inline-flex',
      alignItems: 'center'
    }
  },
  sizes: {
    small: {
      container: /*#__PURE__*/_objectSpread2({
        padding: '1px'
      }, textSizes[300]),
      icon: {
        width: SMALL_CONTENT_SIZE,
        height: SMALL_CONTENT_SIZE,
        padding: '50'
      },
      label: {
        marginX: '100',
        height: SMALL_CONTENT_SIZE
      },
      closeButton: {
        width: SMALL_CONTENT_SIZE,
        height: SMALL_CONTENT_SIZE
      }
    },
    medium: {
      container: /*#__PURE__*/_objectSpread2({
        paddingY: '50',
        paddingX: '50'
      }, textSizes[400]),
      icon: {
        width: MEDIUM_CONTENT_SIZE,
        height: MEDIUM_CONTENT_SIZE,
        padding: '50'
      },
      label: {
        marginX: '200',
        height: MEDIUM_CONTENT_SIZE
      },
      closeButton: {
        width: MEDIUM_CONTENT_SIZE,
        height: MEDIUM_CONTENT_SIZE
      }
    },
    large: {
      container: /*#__PURE__*/_objectSpread2({
        padding: '100'
      }, textSizes[500]),
      icon: {
        width: LARGE_CONTENT_SIZE,
        height: LARGE_CONTENT_SIZE,
        padding: '100'
      },
      label: {
        marginX: '200',
        height: LARGE_CONTENT_SIZE
      },
      closeButton: {
        width: LARGE_CONTENT_SIZE,
        height: LARGE_CONTENT_SIZE
      }
    }
  },
  variants: {
    solid: function solid(props) {
      return {
        container: _objectSpread2({
          borderRadius: '300',
          fontFamily: 'body',
          fontWeight: 'bodySemiBold',
          width: 'fit-content'
        }, colorFor(props.colorScheme, 'container')),
        closeButton: _objectSpread2(_objectSpread2({
          opacity: 1,
          margin: '0',
          borderWidth: '0',
          borderRadius: '3px',
          _focus: {
            shadow: 'none'
          }
        }, colorFor(props.colorScheme, 'closeButton')), {}, {
          _hover: {
            opacity: 1,
            cursor: 'pointer',
            bg: hoverBackgroundFor(props.colorScheme)
          }
        })
      };
    }
  },
  defaultProps: {
    size: 'medium',
    variant: 'solid',
    colorScheme: 'neutralLight'
  }
};

var Text = {
  baseStyle: {
    color: 'neutral.text',
    fontFamily: 'body'
  },
  defaultProps: {
    size: '500'
  },
  sizes: textSizes,
  variants: {
    "default": {
      fontWeight: 'body'
    },
    semiBold: {
      fontWeight: 'bodySemiBold'
    },
    bold: {
      fontWeight: 'bodyBold'
    }
  }
};

var Textarea = {
  baseStyle: function baseStyle(props) {
    return _objectSpread2({}, field(props));
  },
  defaultProps: {
    size: 'default'
  },
  sizes: {
    "default": sizes$4["default"].field,
    tiny: sizes$4.tiny.field,
    small: sizes$4.small.field
  }
};

var stateSelector = function stateSelector(state) {
  return ".chakra-checkbox[data-".concat(state, "] &, .chakra-radio[data-").concat(state, "] &");
};

var TileControl = {
  parts: ['label', 'description'],
  baseStyle: function baseStyle(_ref) {
    var isInvalid = _ref.isInvalid;
    return {
      description: _defineProperty({
        color: isInvalid ? 'danger.500' : 'neutral.600'
      }, stateSelector('disabled'), {
        color: 'neutral.400'
      }),
      label: {
        display: 'inline'
      }
    };
  },
  defaultProps: {
    variant: 'vertical'
  },
  variants: {
    vertical: {
      description: {
        gridRowStart: 2,
        gridRowEnd: 3,
        gridColumnStart: 1,
        gridColumnEnd: 3
      },
      label: {
        gridRowStart: 1,
        gridRowEnd: 2,
        gridColumnStart: 1,
        gridColumnEnd: 3
      }
    },
    horizontal: {
      description: {
        gridRowStart: 1,
        gridRowEnd: 2,
        gridColumnStart: 2,
        gridColumnEnd: 3,
        justifySelf: 'end'
      },
      label: {
        gridColumnEnd: 2
      }
    }
  }
};

var bg = function bg(value) {
  return {
    bg: value,
    '--tooltip-bg': "colors.".concat(value)
  };
};

var Tooltip = {
  baseStyle: function baseStyle(props) {
    var styles = _objectSpread2(_objectSpread2(_objectSpread2({}, theme.components.Tooltip.baseStyle(props)), textSizes[300]), {}, {
      color: props.colorScheme === 'neutralLight' ? 'neutral.text' : 'neutral.0',
      fontFamily: 'body',
      fontWeight: 'bodySemiBold',
      borderRadius: '300'
    });

    switch (props.colorScheme) {
      case 'neutralLight':
        {
          return _objectSpread2(_objectSpread2({}, styles), bg('neutral.200'));
        }

      default:
        {
          return _objectSpread2(_objectSpread2({}, styles), bg('neutral.700'));
        }
    }
  },
  defaultProps: {
    isOpen: false,
    colorScheme: 'neutralDark',
    flip: true
  }
};

/**
 * Combined components object for use in `extendTheme`
 *
 * @example
 * import { extendTheme } from '@chakra-ui/react';
 * import { components } from '.';
 *
 * ```ts
 * const theme = extendTheme({ components });
 * ```
 */

var components = {
  Alert: Alert,
  AlertDialog: AlertDialog,
  Badge: Badge,
  Button: Button,
  Checkbox: Checkbox,
  CloseButton: CloseButton,
  Code: Code,
  Divider: Divider,
  Drawer: Drawer,
  Form: Form,
  FormError: FormError,
  FormLabel: FormLabel,
  Heading: Heading,
  Icon: Icon,
  Input: Input,
  Link: Link,
  List: List,
  Menu: Menu,
  Modal: Modal,
  Popover: Popover,
  Radio: Radio,
  Select: Select,
  Slider: Slider,
  Switch: Switch,
  Table: Table,
  Tabs: Tabs,
  Tag: Tag,
  Text: Text,
  Textarea: Textarea,
  TileControl: TileControl,
  Tooltip: Tooltip,
  // Brand
  BrandButton: Button$1,
  Decoration: Decoration
};

export { _objectWithoutProperties as _, components as c };
